var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallMan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 211.7 516",
    style: {
      enableBackground: "new 0 0 211.7 516"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFB8B8;}\n\t.st1{fill:#2F2E41;}\n\t.st2{fill:#6C63FE;}\n\t.st3{display:none;}\n\t.st4{display:inline;fill:#3F3D56;}\n\t.st5{display:inline;fill:#6C63FE;}\n\t.st6{display:inline;fill:#FFB8B8;}\n\t.st7{display:inline;fill:#2F2E41;}\n\t.st8{display:inline;fill:#CCCCCC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 128.6,
    cy: 75.3,
    rx: 27.5,
    ry: 27.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57,299.6c-4.1-3.7-4.3-10.1-0.6-14.1c0.4-0.4,0.8-0.8,1.3-1.2l3.8-33.5l20.9,5.7l-10.2,30.2 c3.1,4.6,1.8,10.9-2.8,14C65.5,303.2,60.4,302.8,57,299.6L57,299.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "41.7,469.3 30.2,461.8 53.5,413.5 70.5,424.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1,458.1l36.3,23.6l0,0l9.1-14.1l0,0l-22.8-14.8c-7.4-4.8-17.4-2.7-22.2,4.8l0,0L1,458.1L1,458.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "143.9,474.2 130.1,474.2 123.6,420.9 143.9,420.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.6,487h43.2l0,0v-16.8l0,0h-27.1c-8.9,0-16.1,7.2-16.1,16.1v0V487L103.6,487z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.7,130.2c1.8,6-4.6,12.5-6.7,18.4c-2.1,5.9-4.9,11.5-6,17.7c-0.8,4.2-18.3,97.6-17.5,103.3 c5.4-1.6,11.2-1.1,16.2,1.5c3.5-6.2,5.6-13.1,6.2-20.2c0.2-4.2,0.2-8.4-0.1-12.6c-0.5-11.9,4.6-23.8,4.8-35.7 c-0.1-4.1,0.3-8.2,1-12.3c0.6-2.8,0.5-8,1.1-10.8c1-4.4-3.2-6.5-2.9-11l1.3-24.8C86.2,139.4,90.5,134.1,88.7,130.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M150.9,234.2c4.4,6.9,13.7,8.4,20.2,13.4c9.9,7.6-15.4,179-23.8,209.4c-22.1-3.3-22.9-3.3-25.4-4.4 c-2.5-1.1-4.8-88.1-10.2-106.1c-10,9.5-41.7,91.3-48.3,109.4c-26.5-6.7,0,0-34.2-8.9c0.3-6.3,50.6-211,52.4-227.1 C104.6,224.4,127.9,229.6,150.9,234.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M158.7,105.5c2.7,8.1-1,39.7-1.3,46.8c-0.4,6.5-0.4,12.9,0,19.4c0.9,11.2,4.2,22.4,2,33.4 c-1.5,7.3-4,14-4.6,21.4c-0.4,5.1-0.3,10.3-1.9,15.2c-5.9-2.6-58.7-11.4-62.6-16.5c2.7-12.9,0.1-26.2,1.8-39.2 c1-7.5,3.5-14.7,4.7-22.2c1.5-9.2,0.8-18.8,3.5-27.8c1.5-4.5,3.4-8.9,5.6-13.1c2.3-4.8,5.2-8.7,6.2-8.7 C114.8,114.4,158.5,104.8,158.7,105.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.9,298.9c0,0-9.1-18.3-9.6-28.8c-0.2-3.8-10.4-18.8-15.1-22.2c-11-8.1-19-62.2-15.3-75.3 c6.4-22.7,17.2-43.9,28.2-64.7c0.3-0.8,0.9-1.5,1.5-2c2.2-1.4,4.6,1.3,6.2,3.5c5.2,7.3,13.7,11.2,21.4,15.5 c7.8,4.3,15.7,10,18.1,18.6c1.6,5.8,0.3,11.9-0.8,17.8s-5.4,10.5-8.6,15.4c-3.7,5.4-13.2,29.6-13.1,32.4c-0.2,17.7-0.4,35.5,1.8,53 c1.2,9.9,2.3,29.9,2.3,29.9L163.9,298.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.9,280c16.8-38.5,15.9-82.4,26.6-123c3.2-12.1,7.4-24.2,6.7-36.7c-0.1-2.2-0.6-4.7-2.5-6 c-1.6-1.1-3.9-0.8-5.7,0c-1.8,0.8-3.4,2.1-5.1,3c-2.8,1.4-6.1,1.9-8.8,3.5c-4,2.4-6.1,7-7.9,11.4c-3.8,9.3-7.6,18.8-8,28.8 c-0.6,19.5,8,38.3,3.5,57.2c-1,3.7-2.1,7.4-3.5,11.1c-4.5,13.1-8.2,26.4-11,40C64.8,271.6,80.2,281.6,80.9,280z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134.3,270.8c-0.9-5.5,2.9-10.6,8.3-11.4c0.6-0.1,1.2-0.1,1.8-0.1l23.7-23.8l12.8,17.6l-26.7,17.2 c-0.5,5.5-5.3,9.6-10.9,9.1C138.8,279,135,275.4,134.3,270.8L134.3,270.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210,216.7c-0.4,3.6-30.3,41.3-46.6,53.6c0.9-4.9-11.8-20.7-15.9-23.2c10.3-9.8,31.8-32.4,32.5-33.7 c2.3-4.5,0-9.9-2-14.6c-6.4-14.9-9.4-31.7-5.3-47.4c1.5-5.9,4.2-11.8,9.2-15.4c2.2-1.6,5.1-2.6,7.4-1.5c1,0.6,1.9,1.4,2.5,2.3 C199.5,146.4,210.3,214.1,210,216.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.3,99.5c-1.6-6.9,6.5-21.6,4.9-28.5c-1.1-4.6-11.9-1.5-14.5-5.5c-2.5-4-6.8-7.3-11.5-7.4 c-5.5-0.1-10.8,4-16,2.2c-5.2-1.8-6.9-9-4.6-14c2.3-5,7.3-8.2,12.2-10.8c8.4-4.3,18.1-7.4,27.1-4.6c5.4,1.7,9.9,5.4,14.3,9 c4,3.3,8.1,6.7,10.8,11.1c5.5,8.6,5.1,20.1,0.5,29.2S150.3,96,141,99.9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-7.3,221.8c-1.6,0.6-2.3,2.4-1.7,3.8l0,0l4.3,9.4l-0.5,0.2l3,6.4l0.5-0.2L14,274.7c1,2.4,3.9,3.6,6.6,2.9 l24.2-6.4c2.2-0.6,3.5-2.8,2.9-4.8c-0.1-0.2-0.1-0.5-0.3-0.6L23,219.1c-1-2-3.5-3.1-5.9-2.6l-23.8,5l0,0 C-6.9,221.5-7.1,221.6-7.3,221.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M12.9,220.1l-12.5,2.6c-0.5,0.1-0.9-0.1-1.2-0.5l0,0c-0.3-0.5-0.8-0.7-1.3-0.6l-2.6,0.6 c-1.3,0.2-2.2,1.6-2,2.8c0,0.1,0.1,0.2,0.1,0.4L16,273.7c0.5,1.2,2.1,1.9,3.5,1.4l24.1-6.7c1.2-0.4,1.8-1.4,1.4-2.5 c0-0.1-0.1-0.2-0.1-0.2l-23.8-46.3c-0.8-1.4-2.5-2.2-4-1.8l-2.7,0.6C14.4,219,13.8,219.8,12.9,220.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "72.6,473.8 57.6,473.8 50.6,420.9 72.6,420.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M28.9,486.5h46.8l0,0v-16.7l0,0H47C37,469.8,28.9,477.3,28.9,486.5L28.9,486.5L28.9,486.5L28.9,486.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "152.8,473.8 137.9,473.8 130.8,420.9 152.8,420.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M109.2,486.5H156l0,0v-16.7l0,0h-28.6C117.2,469.8,109.2,477.3,109.2,486.5L109.2,486.5L109.2,486.5 L109.2,486.5z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 109.2,
    cy: 68,
    rx: 32,
    ry: 29.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-0.2,260.3c0.8-6.1,6.9-10.6,13.7-9.7c0.7,0.1,1.4,0.2,2.1,0.5l17.8-19.8l15.6,7.1L23.3,266 c-2.5,5.9-9.5,8.8-15.9,6.5C2.2,270.5-1,265.4-0.2,260.3L-0.2,260.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M117,97.6c18.9,0.4,34.5-13.4,34.9-30.7c0.4-17.4-14.6-31.8-33.3-32.2c-2.6,0-5.3,0.1-7.8,0.7 c-7-4-15.2-6.6-23.4-5.9S71,34.7,67.9,41.8s0.3,16.3,7.8,19.2c4.9,1.8,10.4,1,15.6,0.2c5.2-0.7,10.9-1.2,15.5,1.2 c4.6,2.4,6.6,9.1,2.5,12.2c-4.4,3.5-6,9.1-4,14.2C107.2,93.6,112.8,97.4,117,97.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M157.1,463.1c3.3,0,5.9-2.4,5.9-5.4v-0.1l-5.7-199h-0.7l-94-1.9L46.3,450.1c-0.1,2.4,1.4,4.7,3.9,5.5h0.1 l18.5,1.1c3.1,1,6.4-0.6,7.4-3.4c0.1-0.2,0.1-0.4,0.1-0.6l30.1-124.1c0.3-1,1.3-1.6,2.3-1.3c0.8,0.1,1.4,0.7,1.6,1.4l22.3,128.9 c0.4,2.5,2.7,4.4,5.5,4.6l18.8,0.8C157,463.1,157,463.1,157.1,463.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M129.5,275.1c11.7,0,21.9-1.7,27.6-6.2c3.6-3,5.2-7.1,4.7-12.1c-2-18.8,1.4-60.2,4.7-91.7 c1.6-14.9-3.5-29.6-13.9-41.2c-10-11-24.6-17.9-40.2-19c-10.8-0.7-35.9-2.4-43.8,16.2c-11.7,27.8-6,40.6-0.4,52.8 c4.7,10.4,9.6,21.2,3.6,41.6c-3.3,11.3-7.3,22.3-12,33.1c-3.3,7.7-4.8,11.5-3.4,14c1.2,2,4.2,2.9,9.2,3.7c1.7,0.2,3.8,0.7,6.4,1.2 C85.1,270.2,109.4,275.1,129.5,275.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M33.4,257.6L33.4,257.6c1.8,0,3.4-0.7,4.5-1.9l33.2-37.2c7-7.9,11.7-17.5,13.5-27.6l10.2-58.8 c1.4-8.3-4.7-16-13.5-17.3s-17.3,4.3-18.8,12.5c0,0.2,0,0.4-0.1,0.6l-4,31.2c-3.8,28.8-15.9,56.2-35,79.1l-2.3,2.8 c-1.7,2-1.6,4.9,0.3,7l7.8,8C30.1,256.9,31.7,257.6,33.4,257.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallMan);
export default __webpack_public_path__ + "static/media/wall_man.c1aff45080ac2866462d41c6ce5a1318.svg";
export { ForwardRef as ReactComponent };